// Layer constants
export var LAYER_ID = 'oskariLayerId';
export var LAYER_TYPE = 'oskariLayerType';
export var LAYER_HOVER = 'oskariHoverLayer';
export var LAYER_CLUSTER = 'oskariClusterLayer';
export var WFS_TYPE = 'wfs';
export var VECTOR_TYPE = 'vector';
export var VECTOR_TILE_TYPE = 'vectortile';
// Feature constants
export var FTR_PROPERTY_ID = 'id';
export var WFS_ID_KEY = '_oid';
export var WFS_FTR_ID_KEY = '__fid';
// Service constants
export var SERVICE_LAYER_REQUEST = 'layerRequest';
export var SERVICE_HOVER = 'hover';
export var SERVICE_CLICK = 'click';
export var VECTOR_STYLE = {
  OSKARI: 'oskari',
  MAPBOX: 'mapbox',
  CESIUM: 'cesium'
};

// WFS render modes
// Note! integration/admin-layerselector bundle doesn't use these constants so remember to update values there if required
export var RENDER_MODE_MVT = 'mvt';
export var RENDER_MODE_VECTOR = 'vector';
export var FEATURE_QUERY_ERRORS = {
  NOT_FOUND: 'not_found',
  NOT_SELECTED: 'not_selected',
  HIDDEN: 'hidden',
  SCALE: 'scale',
  OUT_OF_BOUNDS: 'out_of_bounds'
};

// Status codes for DescribeLayer
export var DESCRIBE_LAYER = {
  UNDEFINED: 'undefined',
  PENDING: 'pending',
  LOADED: 'loaded',
  ERROR: 'error',
  PREDEFINED: 'predefined'
};